module.exports = __webpack_public_path__ + "static/img/logo-white.2afec4b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-white.svg
// module id = zv6/
// module chunks = 0